import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { memo } from 'react';
import { TransactionCard, WarningMessage } from './components';
import { TransactionDetailSectionProvider } from './context/TransactionDetailSectionContext';
import styles from './TransactionDetailSection.module.scss';
import { TransactionDetailSectionProps } from './types';

const cx = classnames.bind(styles);

export const TransactionDetailSection = memo(
  ({
    transactionList = [],
    tooltips,
    warningMessage,
    isSelected = false,
    fields,
  }: TransactionDetailSectionProps) => {
    const { t } = useTranslation();
    // Validate and sanitize input
    const validTransactions = Array.isArray(transactionList)
      ? transactionList
      : [];
    const hasTransactions = validTransactions.length > 0;
    const displayTransactions = hasTransactions ? validTransactions : [];

    const contextValue = {
      tooltips,
      isSelected,
      fields,
    };

    return (
      <TransactionDetailSectionProvider value={contextValue}>
        <div className={cx('container')}>
          <div className={cx('listViewContainer')}>
            {warningMessage?.enabled && (
              <WarningMessage message={warningMessage.message} />
            )}
            {displayTransactions.length > 0 ? (
              displayTransactions.map((transaction, index) => (
                <TransactionCard
                  key={transaction.id || `empty-${index}`}
                  transaction={transaction}
                  index={index}
                />
              ))
            ) : (
              <div className={cx('emptyMessage')}>
                {t('no_transaction_details_available')}
              </div>
            )}
          </div>
        </div>
      </TransactionDetailSectionProvider>
    );
  }
);

TransactionDetailSection.displayName = 'TransactionDetailSection';
